import React from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import {
  InovationIcon,
  AdvantureIcon,
  RelationshipIcon,
  SustainabilityIcon,
  TransparanceIcon,
  CommunityIcon,
  LocationIcon,
} from '../../assets';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './AboutPage.module.css';
import storyimg from './story.png';
import pattern from './pattern.png';
import saraimg from './sara.png';
import erikimg from './erik.png';

import { WithMarker } from '../../components/Map/Map.example';
import ContactusForm from './ContactusForm';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Sommly',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>

            <div className={css.layoutWrapperHeader}>
              <div className={css.overlay} />
              <div className={css.headerContent}>
                <h1>About Us</h1>
                <h3>
                  Our mission is to tear down barriers to access technology and to enable all wineries to reach the global marketplace.
                </h3>
              </div>
            </div>

            <div className={css.ourstoryWrapper}>
              <div className={css.pattern}>
                <img src={pattern} alt="" />
              </div>
              <div className={css.ourstoryWrapperContainer}>
                <h2>Our Story</h2>
                <div className={css.ourstoryContent}>
                  <div className={css.storyFirstColumn}>
                    <p>
                      Sommly’s goal is to transform the wine shopping experience for consumers and enable growth for wineries by increasing exposure to these small businesses’ offerings and providing an easy to use platform that drives traffic and revenue via reviews, subscriptions, events, bookings and eCommerce capabilities.
                      <br /><br />
                      Retail is an expensive channel for wineries because distributors and retailers leave them with only a fraction of gross margin. Therefore retail is only economical for the world’s largest producers.
                      <br /><br />
                      Sommly will bring global commercial reach to small and artisanally operated businesses while empowering and educating consumers via reviews, community engagement, events and gamification.
                    </p>
                  </div>
                  <div>
                    <img width="100%" height="100%" src={storyimg} alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className={css.teamWrapper}>
              <div className={css.teamContainer}>
                <div className={css.columns}>
                  <div>
                    <img src={saraimg} alt="" />
                  </div>
                  <div className={css.columnsInfo}>
                    <h4>Sara Wagner</h4>
                    <h6>Co-Founder</h6>
                    <p>
                      Sara has over 10 years of experience in management consulting, technology, and product portfolio management.
                      <br /> <br />
                      Sara has an MBA from Rice University and a BS from Texas A&M University. Certified level two sommelier by the National Wine School.
                    </p>
                  </div>
                </div>
                <div className={css.columns}>
                  <div>
                    <img src={erikimg} alt="" />
                  </div>
                  <div className={css.columnsInfo}>
                    <h4>Erik  Wagner</h4>
                    <h6>Co-Founder</h6>
                    <p>
                      Erik has over 14 years of experience: consulting and building and leading marketing teams for technology companies.
                      <br /> <br />
                      Erik has an MBA from the University of Texas, Austin and a BA from Union College, NY. Certified level two sommelier by the National Wine School.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className={css.sommlycorevaluesWrapper}>
              <h2>Sommly’s Core Values</h2>
              <div className={css.sommlycorevaluesContainer}>
                <div className={css.sommlyvaluesColumns}>
                  <div><InovationIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Innovation</h4>
                    <p>We rely on the power of invention to deliver value to customers. We believe there’s always more to learn and good reason to evolve. </p>
                  </div>
                </div>
                <div className={css.sommlyvaluesColumns}>
                  <div><AdvantureIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Adventure over Routine</h4>
                    <p>We love trying new things and aren’t afraid of the unknown. We take calculated risks and learn from our mistakes.</p>
                  </div>
                </div>
                <div className={css.sommlyvaluesColumns}>
                  <div><RelationshipIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Win-Win Relationships</h4>
                    <p>
                      We believe in an ecosystem where stakeholders prosper together.
                    </p>
                  </div>
                </div>
                <div className={css.sommlyvaluesColumns}>
                  <div><SustainabilityIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Sustainability</h4>
                    <p>
                      We celebrate and support businesses that choose environmental sustainability over maximizing bottom line.
                    </p>
                  </div>
                </div>
                <div className={css.sommlyvaluesColumns}>
                  <div><TransparanceIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Transparency</h4>
                    <p>
                      We prioritize reliability, transparency and objectivity over opportunities that could compromise trust.
                    </p>
                  </div>
                </div>
                <div className={css.sommlyvaluesColumns}>
                  <div><CommunityIcon /></div>
                  <div className={css.columnsInfo}>
                    <h4>Community</h4>
                    <p>
                      We love wine and refuse to become too intimidating for the first-time visitor.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div id="contactus">
              <ContactusForm />
            </div>

            <div className={css.locationWrapper}>
              <LocationIcon />
              <h2>We're located in Austin, TX</h2>
            </div>






          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
